export default "/images/vendor/flag-icons/flags/4x3/kz.svg?492e81d5876af1337afca9478e37acc4";